import React from 'react';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Row, Col, Container } from 'reactstrap';

import ClockC from './clock';
import { version_system } from 'core/constants';
import * as userActions from 'modules/user/action';
import { checkPermissions } from 'core/generalFunctions';

@connect((store) => ({
  userId: store.getIn(['user', 'userId']),
  roles: store.getIn(['user', 'roles']), //No lo uso, pero fuerza el renderizado
  registros: store.getIn(['registros', 'list']),
  cantidadReservasProbables: store.getIn(['reservas', 'cantidadreservasProbables']),
  dashboard: store.getIn(['general', 'dashboard']),
  cantidadDeReportes: store.getIn(['reportes', 'cuantosHay']),
  cantidadDeSolicitudes: store.getIn(['gruposSolicitudes', 'cuantosHay']),
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: null,
    };
  }
  componentDidMount() {
    if (!this.props.userId) this.props.dispatch(push('/'));
  }
  linkTo(link, index) {
    this.props.dispatch(push(link));
    this.setState({ selectedIndex: index });
  }
  logout() {
    this.props.dispatch(userActions.logout());
  }
  goTo = (path) => this.props.dispatch(push(path));
  render() {
    return (
      <Container fluid style={{ paddingRight: '-10px' }}>
        <Row style={{ padding: '0px' }}>
          <Col md="10" style={{ padding: '0px' }}>
            <div>
              <MaterialUI.AppBar
                className="no-print"
                title={this.props.dashboard.get('titulo')}
                iconElementLeft={<ClockC />}
                iconElementRight={
                  <MaterialUI.IconButton primary={true} iconClassName="fa fa-bars" className="fullWidthComponent noPadding hidden show_on_phone" onTouchTap={() => window.location.assign('#menu')} />
                }
              />
            </div>
            <div>{this.props.children}</div>
          </Col>
          <Col md="2" style={{ padding: '0px' }} id="menu">
            <MaterialUI.Paper zDepth={2} className="no-print center_on_mobile">
              <MaterialUI.AppBar showMenuIconButton={false} className="no-print" title="JAITS" />
              <div className="contentScroll">
                <MaterialUI.MenuItem
                  insetChildren={true}
                  primaryText="Reservas"
                  className="center_on_mobile"
                  leftIcon={<FontAwesome className="iconBar" name="ticket" />}
                  onTouchTap={this.linkTo.bind(this, '/dashboard/reservas/main', 0)}
                />
                {checkPermissions(['admin', 'asignador_viajes', 'administrador_viajes']) && (
                  <MaterialUI.MenuItem
                    insetChildren={true}
                    primaryText="Viajes"
                    leftIcon={<FontAwesome className="iconBar" name="bus" />}
                    onTouchTap={this.linkTo.bind(this, '/dashboard/viajes', 2)}
                  />
                )}
                {checkPermissions(['admin', 'administrador_abonados', 'administrador_pasajes']) && (
                  <MaterialUI.MenuItem
                    insetChildren={true}
                    primaryText="Abonados"
                    leftIcon={<FontAwesome className="iconBar" name="user" />}
                    onTouchTap={this.linkTo.bind(this, '/dashboard/abonados', 1)}
                  />
                )}
                {checkPermissions(['admin', 'administrador_paradas', 'ver_paradas']) && (
                  <MaterialUI.MenuItem primaryText="Paradas" onTouchTap={this.goTo.bind(this, '/dashboard/paradas')} leftIcon={<FontAwesome className="iconBar" name="map-marker" />} />
                )}
                <MaterialUI.MenuItem primaryText="Trayectos" onTouchTap={this.goTo.bind(this, '/dashboard/trayectos')} leftIcon={<FontAwesome className="iconBar" name="road" />} />
                {this.props.cantidadreservasProbables > 0 && (
                  <MaterialUI.MenuItem
                    primaryText="Reservas probables"
                    leftIcon={
                      <div>
                        <FontAwesome className="iconBar" name="ticket" />
                        <MaterialUI.Badge badgeContent={this.props.cantidadreservasProbables} secondary badgeStyle={{ top: -25, right: -15 }} className="p-3" />
                      </div>
                    }
                    onTouchTap={this.linkTo.bind(this, '/dashboard/reservas/reservasPendientes/true', 4)}
                  />
                )}
                {checkPermissions(['admin', 'administrador_rutinas', 'ver_rutinas']) && (
                  <MaterialUI.MenuItem primaryText="Rutinas" onTouchTap={this.goTo.bind(this, '/dashboard/rutinas')} leftIcon={<FontAwesome className="iconBar" name="clock-o" />} />
                )}
                {checkPermissions(['admin', 'administrador_vehiculos', 'ver_vehiculos']) && (
                  <MaterialUI.MenuItem primaryText="Vehiculos" onTouchTap={this.goTo.bind(this, '/dashboard/vehiculos')} leftIcon={<FontAwesome className="iconBar" name="bus" />} />
                )}
                {checkPermissions(['admin', 'administrador_vehiculos']) && (
                  <MaterialUI.MenuItem primaryText="Dispositivos" onTouchTap={this.goTo.bind(this, '/dashboard/dispositivos')} leftIcon={<FontAwesome className="iconBar" name="tablet" />} />
                )}
                {checkPermissions(['admin', 'administrador_abonados', 'administrador_pasajes']) && (
                  <MaterialUI.MenuItem
                    primaryText="Reportes"
                    leftIcon={
                      <div>
                        <FontAwesome className="iconBar" name="exclamation-triangle" />
                        {this.props.cantidadDeReportes > 0 && <MaterialUI.Badge badgeContent={this.props.cantidadDeReportes} secondary badgeStyle={{ top: -25, right: -15 }} className="p-3" />}
                      </div>
                    }
                    onTouchTap={this.linkTo.bind(this, '/dashboard/reportes', 5)}
                  />
                )}

                {checkPermissions(['admin', 'administrador_precios']) && (
                  <MaterialUI.MenuItem primaryText="Precios" leftIcon={<FontAwesome className="iconBar" name="usd" />} onTouchTap={this.linkTo.bind(this, '/dashboard/precios')} />
                )}

                {checkPermissions(['admin', 'administrador_reservas']) && (
                  <MaterialUI.MenuItem primaryText="Penalizaciones" leftIcon={<FontAwesome className="iconBar" name="user-times" />} onTouchTap={this.linkTo.bind(this, '/dashboard/penalizaciones')} />
                )}

                {checkPermissions(['admin', 'ver_mapa', 'administrador_viajes']) && (
                  <MaterialUI.MenuItem primaryText="Mapa" onTouchTap={this.goTo.bind(this, '/dashboard/mapa')} leftIcon={<FontAwesome className="iconBar" name="map" />} />
                )}

                {checkPermissions(['admin', 'administrador_grupos']) && (
                  <MaterialUI.MenuItem primaryText="Grupos" onTouchTap={this.goTo.bind(this, '/dashboard/grupos')} leftIcon={<FontAwesome className="iconBar" name="users" />} />
                )}
                {checkPermissions(['admin', 'administrador_grupos']) && this.props.cantidadDeSolicitudes > 0 && (
                  <MaterialUI.MenuItem
                    primaryText="Solicitudes"
                    onTouchTap={this.goTo.bind(this, '/dashboard/gruposSolicitudes', 6)}
                    leftIcon={
                      <div>
                        <FontAwesome className="iconBar" name="address-book-o" />
                        <MaterialUI.Badge badgeContent={this.props.cantidadDeSolicitudes} secondary badgeStyle={{ top: -25, right: -15 }} className="p-3" />
                      </div>
                    }
                  />
                )}
                <MaterialUI.MenuItem primaryText="Mensajes" onTouchTap={this.goTo.bind(this, '/dashboard/mensajes')} leftIcon={<FontAwesome className="iconBar" name="envelope-o" />} />

                <MaterialUI.MenuItem
                  primaryText="Reservas pendientes"
                  onTouchTap={this.goTo.bind(this, '/dashboard/reservas/reservasPendientes/false')}
                  leftIcon={<FontAwesome className="iconBar" name="ticket" />}
                />
                {checkPermissions(['admin', 'administrador_feriados', 'ver_feriados']) && (
                  <MaterialUI.MenuItem primaryText="Feriados" onTouchTap={this.goTo.bind(this, '/dashboard/feriados')} leftIcon={<FontAwesome className="iconBar" name="calendar" />} />
                )}
                {checkPermissions(['admin', 'ver_logs']) && (
                  <MaterialUI.MenuItem primaryText="Actividad" onTouchTap={this.goTo.bind(this, '/dashboard/logs')} leftIcon={<FontAwesome className="iconBar" name="bell" />} />
                )}

                {checkPermissions(['admin', 'ver_logs']) && this.props.registros && this.props.registros.size > 0 && (
                  <MaterialUI.MenuItem
                    primaryText="Registro"
                    leftIcon={
                      <div>
                        <FontAwesome className="iconBar" name="book" />
                        <MaterialUI.Badge badgeContent={this.props.registros.size} primary badgeStyle={{ top: -25, right: -15 }} className="p-3" />
                      </div>
                    }
                    onTouchTap={this.linkTo.bind(this, '/dashboard/registros', 3)}
                  />
                )}
                {checkPermissions(['admin']) && (
                  <MaterialUI.MenuItem primaryText="Roles" onTouchTap={this.goTo.bind(this, '/dashboard/roles')} leftIcon={<FontAwesome className="iconBar" name="lock" />} />
                )}
                <MaterialUI.MenuItem primaryText={version_system} leftIcon={<FontAwesome className="iconBar" name="code-fork" />} />
                <MaterialUI.MenuItem primaryText="Salir" onTouchTap={this.logout.bind(this)} leftIcon={<FontAwesome className="iconBar" name="sign-out" />} />
              </div>
            </MaterialUI.Paper>
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/general/components/dashboard.js